/**
 * Lightweight compliance deep-link helpers (mirrors ComplianceReport navigation).
 */
export function unverifiedInventoryPath(row) {
  const status = row?.verification?.status || "Pending";
  const verification =
    status === "Overdue" || status === "Pending" ? status : "Pending";
  if (row?._id) return `/assets?id=${encodeURIComponent(row._id)}`;
  return `/assets?status=Assigned&verification=${encodeURIComponent(verification)}`;
}

export function leaverInventoryPath(row) {
  const email = String(row?.email || "").trim().toLowerCase();
  return `/assets?assignee=${encodeURIComponent(email)}`;
}

export function analyticsStatusPath(status) {
  return `/assets?status=${encodeURIComponent(status)}`;
}
